export const AppleLogo = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 0.45 0.45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M.236.088A.01.01 0 0 1 .225.077C.225.034.26 0 .304 0a.01.01 0 0 1 .011.011.077.077 0 0 1-.079.077"
        fill="#000"
      />
      <path
        d="M.236.088A.01.01 0 0 1 .225.077C.225.034.26 0 .304 0a.01.01 0 0 1 .011.011.077.077 0 0 1-.079.077M.4.32a.01.01 0 0 1 .003.014Q.346.45.304.45a.1.1 0 0 1-.04-.013.06.06 0 0 0-.062-.001.1.1 0 0 1-.045.014C.115.45.045.322.045.252.045.177.085.12.146.12Q.189.12.22.133A.03.03 0 0 0 .247.132.2.2 0 0 1 .314.12q.05 0 .088.048A.01.01 0 0 1 .4.183Q.36.213.359.251.359.29.4.319"
        fill="#000"
      />
      <path
        d="M.4.32a.01.01 0 0 1 .003.014Q.346.45.304.45a.1.1 0 0 1-.04-.013.06.06 0 0 0-.062-.001.1.1 0 0 1-.045.014C.115.45.045.322.045.252.045.177.085.12.146.12Q.189.12.22.133A.03.03 0 0 0 .247.132.2.2 0 0 1 .314.12q.05 0 .088.048A.01.01 0 0 1 .4.183Q.36.213.359.251.359.29.4.319"
        fill="#000"
      />
    </svg>
  );
};
